import { $auth, $specialClaims, LogoutManager, useAuth, useMeasurementUnit, useTenantConfiguration } from '@msdk/common'
import { User } from '@msdk/definitions'
import { SESSION_ENDING } from 'hooks'
import { ReactElement, useEffect } from 'react'
import { useRecoilState, useRecoilValue } from 'recoil'

interface Props {
  children?: ReactElement
  fallback: ReactElement
}

export function AuthSuspense({ children, fallback }: Props) {
  const auth = useAuth()
  const authInner = auth.auth
  const [authCtx, setAuthCtx] = useRecoilState($auth)

  // These are not really things related to authentication
  // but there is still a need to have them initialized before application startup
  // for now they are here since this is a convienent suspense, in the future
  // it would be good to have a dedicated suspense for these kind of initializations.
  const specialClaims = useRecoilValue($specialClaims)
  const tenantConfiguration = useTenantConfiguration()
  const conversions = useMeasurementUnit()

  useEffect(() => {
    setAuthCtx(authInner?.userData as User)
  }, [authInner, setAuthCtx])

  // effect to initialize the logout and listend for logouts from other tabs
  useEffect(() => {
    const logoutManager = (window as any).LogoutManager as LogoutManager
    logoutManager.setOnLogoutReceived((args?: any) => auth.onLogout(args, false))

    return () => {
      logoutManager.cleanOnLogoutReceived()
    }
  }, [])

  if (
    !SESSION_ENDING &&
    authCtx &&
    authCtx?.access_token &&
    authInner?.userData &&
    specialClaims &&
    tenantConfiguration &&
    conversions
  )
    return <>{children}</>
  else return <>{fallback}</>
}
